import DOMPurify from "dompurify";

/**
 * Sanitises HTML written with the WYSIWYG editor before it is put on a page. The editor only produces
 * harmless markup, the API behind it accepts any string — so stored HTML is never trusted as it is.
 * `target` is kept on purpose: the editor's links open in a new tab (with `rel="noopener noreferrer"`),
 * DOMPurify would otherwise drop that and have them navigate away from the application.
 */
export const sanitizeRichTextHtml = (html?: string | null): string => DOMPurify.sanitize(html ?? "", { ADD_ATTR: ["target"] });
